import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/** identity: foydalanuvchilar, rollar, jamoa, profil. */
export const workRoutes: RouteObject[] = [
  { path: 'users', ...page(() => import('./pages/UsersPage')) },
  { path: 'profile', ...page(() => import('./pages/ProfilePage')) },
];

export const sellerRoutes: RouteObject[] = [
  { path: 'team', ...page(() => import('./pages/TeamPage')) },
  { path: 'profile', ...page(() => import('./pages/ProfilePage')) },
];
